module.exports = __webpack_public_path__ + "media/images/countryrect/pr-fd2c438bbbbf27e42e0ec2a770d7979b.svg";